import type React from 'react';

import type { IconProps } from './BaseIcon';
import { BaseIcon } from './BaseIcon';

export const MoonIcon: React.FC<IconProps> = props => (
  <BaseIcon viewboxSize="xl" {...props}>
    <path d="M11 9c0-.589.044-1.168.126-1.734A9.998 9.998 0 0 0 6 16c0 5.523 4.477 10 10 10a9.996 9.996 0 0 0 8.733-5.127c-.566.082-1.145.127-1.733.127-6.627 0-12-5.373-12-12Zm2 0c0 5.523 4.477 10 10 10 1.097 0 2.15-.176 3.136-.501l1.884-.621-.622 1.884C25.82 24.545 21.315 28 16 28 9.373 28 4 22.627 4 16c0-5.315 3.455-9.82 8.238-11.397l1.885-.623-.622 1.885A9.989 9.989 0 0 0 13 9Z" />
  </BaseIcon>
);
